<template>
  <div class="products">
    <h2 class="products__title">{{ $t('productsTitle') }}</h2>
    <div class="products__items">
      <product-component
        v-for="product of products"
        :key="product.title"
        :product="product"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import { config } from '@/setup/config'
import { Product } from '../../reusable/types'
import ProductComponent from './product.vue'

@Component({
  components: {
    ProductComponent
  },
  i18n: {
    messages: {
      en: {
        'productsTitle': 'Select a project',
      },
      ru: {
        'productsTitle': 'Выберите продукт'
      }
    }
  }
})
export default class ProductsPage extends Vue {
  get products (): Product[] {
    return config.products
  }
}
</script>

<style lang="scss" scoped>
.products {
  &__title {
    margin: 20px 0 0;
    font-weight: $font-weight-light;
    font-size: $font-size-display;
    color: $primary;
    letter-spacing: -1px;
  }
  &__items {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    margin: 0 -40px;
    &::after {
      content: "";
      flex: 1 0 0;
      margin: 40px 40px 10px;
    }
  }
}
</style>